import React from 'react';
import { choose } from '../../utils/platform';
import { useUserManagement } from './useUserManagement';
import UserManagementDesktop from './UserManagement.desktop';
import UserManagementMobile from './UserManagement.mobile';

const UserManagementView = choose(UserManagementDesktop, UserManagementMobile);

export default function UserManagement() {
  const vm = useUserManagement();
  return <UserManagementView vm={vm} />;
}
